module.exports = __webpack_public_path__ + "img/quest_icon_0056_magic.1deadc23.png";